/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcademicProfileTemplateDto } from '../models/AcademicProfileTemplateDto';
import type { AcademicProfileTemplateLiteResponse } from '../models/AcademicProfileTemplateLiteResponse';
import type { CreateAcademicProfileTemplateRequest } from '../models/CreateAcademicProfileTemplateRequest';
import type { UpdateAcademicProfileTemplateRequest } from '../models/UpdateAcademicProfileTemplateRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AcademicProfileTemplateRestControllerService {
  /**
   * createProfileTemplate
   * @returns AcademicProfileTemplateDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static createProfileTemplateUsingPost({
    request,
  }: {
    /**
     * request
     */
    request: CreateAcademicProfileTemplateRequest;
  }): CancelablePromise<AcademicProfileTemplateDto | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/academic-profile-template',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * updateProfileTemplate
   * @returns AcademicProfileTemplateDto OK
   * @throws ApiError
   */
  public static updateProfileTemplateUsingPatch({
    request,
  }: {
    /**
     * request
     */
    request: UpdateAcademicProfileTemplateRequest;
  }): CancelablePromise<AcademicProfileTemplateDto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/academic-profile-template',
      body: request,
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

  /**
   * getClassLevelProfileTemplates
   * @returns AcademicProfileTemplateLiteResponse OK
   * @throws ApiError
   */
  public static getClassLevelProfileTemplatesUsingGet({
    classLevelId,
    sessionId,
    search,
  }: {
    /**
     * classLevelId
     */
    classLevelId: string;
    /**
     * sessionId
     */
    sessionId: string;
    /**
     * search
     */
    search?: string;
  }): CancelablePromise<Array<AcademicProfileTemplateLiteResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/academic-profile-template/session/{sessionId}/classlevel/{classLevelId}',
      path: {
        classLevelId: classLevelId,
        sessionId: sessionId,
      },
      query: {
        search: search,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * toggleUsesAcademicProfile
   * @returns any OK
   * @throws ApiError
   */
  public static toggleUsesAcademicProfileUsingPut(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/academic-profile-template/toggle',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getProfileTemplate
   * @returns AcademicProfileTemplateDto OK
   * @throws ApiError
   */
  public static getProfileTemplateUsingGet({
    profileTemplateId,
  }: {
    /**
     * profileTemplateId
     */
    profileTemplateId: string;
  }): CancelablePromise<AcademicProfileTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/academic-profile-template/{profileTemplateId}',
      path: {
        profileTemplateId: profileTemplateId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * deleteTemplate
   * @returns any OK
   * @throws ApiError
   */
  public static deleteTemplateUsingDelete({
    profileTemplateId,
  }: {
    /**
     * profileTemplateId
     */
    profileTemplateId: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/academic-profile-template/{profileTemplateId}',
      path: {
        profileTemplateId: profileTemplateId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
